import serverCall from "../../serverCall";
import axios from "axios";


const createCheckoutSession = async () => {
  try {
    const response = await serverCall.post("/subscription/purchase-subscription"
      //    {
      //   plan_id: plan_id,
      // }
    );
    return response;
  } catch (error) {
    throw error;
  }
};

const getSubscription = async () => {
  try {
    const response = await serverCall.get("/subscription/subscriptions");
    return response;
  } catch (error) {
    // 404 = no subscription or user not found - treat as no active subscription
    if (error?.response?.status === 404) {
      return { data: null };
    }
    throw error;
  }
};

const activeSubscription = async () => {
  try {
    const response = await serverCall.get("/subscription/user/active-subscriptions");
    return response;
  } catch (error) {
    throw error;
  }
};

const cancelSubscription = async (plan_id) => {
  try {
    const response = await serverCall.post("/subscription/cancel-subscription", {
      id: plan_id,
    });
    return response;
  } catch (error) {
    throw error;
  }
};



const IndividualSubscriptionService = {
  createCheckoutSession,
  getSubscription,
  cancelSubscription,
  activeSubscription,
};

export default IndividualSubscriptionService;
